export default __webpack_public_path__ + "static/media/metaverse-icon-1.b79c8328.png";